
  export default {
    props: {
      product: { type: String, default: 'default' },
      videoId: { type: String, required: true }
    },

    data () { return { ytClicked: false, ytShown: false, ytSource: '' }; },

    methods: {
      ytClick () {
        if (this.ytClicked) {
          return;
        }
        this.ytClicked = true;
        this.ytSource = `https://www.youtube-nocookie.com/embed/${this.videoId}?rel=0&autoplay=1`;
        setTimeout(() => { this.ytShown = true; }, 300);
      }
    }
  };
